import { Box, Loader, PulseAnimation } from '@wix/design-system';
import { HintSmall, LockLockedSmall, StatusAlertFilledSmall, StatusWarningFilledSmall, TimeSmall } from '@wix/wix-ui-icons-common';
import React, { useCallback, useEffect, useState } from 'react';
import { RuleListStatus } from '../../types';
import { dataHooks } from '../../utils/datahooks';
import { ThemeAwareIcon } from '../../utils/theme-aware-icon';
import { usePreviousState } from '../../utils/use-previous-state';
import { wdsThemeColors } from '../../utils/wds-theme-colors';
import { CompletedTaskIcon } from './completed-task-icon';
export const PrefixStatusIcon = _ref => {
  let {
    ruleResult
  } = _ref;
  const {
    onStatusChange,
    status,
    isLoading
  } = ruleResult;
  const [isPulseActive, setIsPulseActive] = useState(false);
  const prevStatus = usePreviousState(status);
  useEffect(() => {
    if (prevStatus !== undefined && prevStatus !== status) {
      if (prevStatus === RuleListStatus.failed && status === RuleListStatus.passed) {
        setIsPulseActive(true);
      }
      onStatusChange == null || onStatusChange();
    }
  }, [prevStatus, setIsPulseActive, status, onStatusChange]);
  const handlePulseEnd = useCallback(() => {
    setIsPulseActive(false);
  }, []);
  const PassedIcon = useCallback(() => {
    return /*#__PURE__*/React.createElement(Box, {
      padding: "2px"
    }, /*#__PURE__*/React.createElement(Box, {
      position: "relative",
      zIndex: 2
    }, /*#__PURE__*/React.createElement(PulseAnimation, {
      active: isPulseActive,
      borderRadius: "50%",
      color: "G10",
      delay: "300ms",
      loop: false,
      onEnd: handlePulseEnd
    }, /*#__PURE__*/React.createElement(ThemeAwareIcon, {
      color: wdsThemeColors.statusSuccess,
      dataHook: dataHooks.rulesListPrefixIconComplete
    }, /*#__PURE__*/React.createElement(CompletedTaskIcon, null)))));
  }, [isPulseActive, handlePulseEnd]);
  const FailedIcon = () => {
    return /*#__PURE__*/React.createElement(ThemeAwareIcon, {
      color: wdsThemeColors.statusDestructive,
      dataHook: dataHooks.rulesListPrefixIconFailed
    }, /*#__PURE__*/React.createElement(StatusAlertFilledSmall, null));
  };
  const LoadingIcon = () => {
    return /*#__PURE__*/React.createElement(Box, {
      dataHook: dataHooks.rulesListPrefixIconLoading
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    }));
  };
  const DisabledIcon = () => {
    return /*#__PURE__*/React.createElement(ThemeAwareIcon, {
      color: wdsThemeColors.iconSecondary,
      dataHook: dataHooks.rulesListPrefixIconDisabled
    }, /*#__PURE__*/React.createElement(LockLockedSmall, null));
  };
  const RecommendationIcon = () => {
    return /*#__PURE__*/React.createElement(ThemeAwareIcon, {
      dataHook: dataHooks.rulesListPrefixIconRecommendation
    }, /*#__PURE__*/React.createElement(HintSmall, {
      size: "18px"
    }));
  };
  const PendingIcon = () => {
    return /*#__PURE__*/React.createElement(ThemeAwareIcon, {
      color: wdsThemeColors.statusWarning,
      dataHook: dataHooks.rulesListPrefixIconPending
    }, /*#__PURE__*/React.createElement(TimeSmall, {
      size: "18px"
    }));
  };
  const ErrorIcon = useCallback(() => {
    return /*#__PURE__*/React.createElement(ThemeAwareIcon, {
      color: wdsThemeColors.statusWarning,
      dataHook: dataHooks.rulesListPrefixIconError
    }, /*#__PURE__*/React.createElement(StatusWarningFilledSmall, {
      size: "18px"
    }));
  }, []);
  const getStatusIcon = useCallback(() => {
    if (isLoading) {
      return /*#__PURE__*/React.createElement(LoadingIcon, null);
    }
    switch (status) {
      case RuleListStatus.passed:
        return /*#__PURE__*/React.createElement(PassedIcon, null);
      case RuleListStatus.failed:
        return /*#__PURE__*/React.createElement(FailedIcon, null);
      case RuleListStatus.error:
        return /*#__PURE__*/React.createElement(ErrorIcon, null);
      case RuleListStatus.disabled:
        return /*#__PURE__*/React.createElement(DisabledIcon, null);
      case RuleListStatus.recommendation:
        return /*#__PURE__*/React.createElement(RecommendationIcon, null);
      case RuleListStatus.pending:
        return /*#__PURE__*/React.createElement(PendingIcon, null);
      default:
        return null;
    }
  }, [ErrorIcon, isLoading, PassedIcon, status]);
  return /*#__PURE__*/React.createElement(Box, {
    paddingTop: "3px"
  }, getStatusIcon());
};
//# sourceMappingURL=prefix-status-icon.js.map